export default {
    fixedFrameMode: false,
    firstPageLoad: true,
    releaseMode: process.env.REACT_APP_RELEASE_MODE,
    googleAnalyticsTrackingID: process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID
}	